import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { User } from '../../../features/user-management/api/types';
import { getToken } from '../../../baseQuery/utils';
import { useEffect, useState } from 'react';
import { RootState } from '../../../store';

export const useUserRole = (): { isLoading: boolean; permissions: User['roleName'][] } => {
    const token = getToken();
    const [permissionsLoading, setPermissionsLoading] = useState(true);
    const [permissions, setPermissions] = useState<User['roleName'][]>([]);
    const { inactivityReason } = useSelector((state: RootState) => state.inactivityScreen);

    useEffect(() => {
        if (token) {
            const jwtPayload: { permissions: User['roleName'][] } | null = jwtDecode(token);

            if (jwtPayload?.permissions) {
                setPermissions(jwtPayload.permissions);
                setPermissionsLoading(false);
            }
        }
    }, [token]);

    return {
        isLoading: !inactivityReason && permissionsLoading,
        permissions,
    };
};
